import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "exam-time"
};
const _hoisted_2 = {
  key: 1,
  class: "paper-context"
};
const _hoisted_3 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_4 = {
  class: "icon play-icon loading-ani",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_5 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_6 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_7 = {
  class: "icon play-icon loading-ani",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_8 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_9 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_10 = {
  class: "icon play-icon loading-ani",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_11 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_12 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_13 = {
  class: "icon play-icon loading-ani",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_14 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_15 = {
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_16 = {
  class: "icon play-icon loading-ani",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_17 = {
  class: "icon over-icon",
  style: {
    "width": "25px",
    "height": "25px"
  }
};
const _hoisted_18 = {
  key: 3,
  class: "loading"
};
const _hoisted_19 = {
  class: "loading-box"
};
const _hoisted_20 = {
  class: "title"
};
const _hoisted_21 = {
  class: "tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_mm_sequencing = _resolveComponent("mm_sequencing");
  const _component_mcq = _resolveComponent("mcq");
  const _component_sequencing = _resolveComponent("sequencing");
  const _component_saq = _resolveComponent("saq");
  const _component_writing_listen = _resolveComponent("writing_listen");
  const _component_MenuBox = _resolveComponent("MenuBox");
  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.paperInfo.items ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    style: {
      "background": "none",
      "border": "none",
      "padding": "0",
      "margin-right": "5px",
      "font-size": "20px"
    },
    icon: $setup.Timer,
    size: "large"
  }, null, 8, ["icon"]), _createElementVNode("p", null, [_cache[9] || (_cache[9] = _createTextVNode(" 考试时间", -1)), _createElementVNode("span", null, _toDisplayString($setup.timeText), 1)]), _withDirectives(_createVNode(_component_el_button, {
    color: "#1d5595",
    type: "success",
    size: "large",
    onClick: _cache[0] || (_cache[0] = $event => $setup.finishExam(1))
  }, {
    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("交 卷", -1)]))]),
    _: 1
  }, 512), [[_vShow, $props.examInfo.subdivide == 3]])])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mm-drag' ? (_openBlock(), _createBlock(_component_mm_sequencing, {
    key: 0,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mcq' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'mmcq' || $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'judge' ? (_openBlock(), _createBlock(_component_mcq, {
    key: 1,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[2] || (_cache[2] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'sequencing' ? (_openBlock(), _createBlock(_component_sequencing, {
    key: 2,
    questionInfo: $setup.paperInfo.items[$setup.itemNo],
    allAnswers: $setup.cache.answers,
    onSetAnswer: $setup.setAnswer
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[3] || (_cache[3] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["questionInfo", "allAnswers", "onSetAnswer"])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'saq' ? (_openBlock(), _createBlock(_component_saq, {
    key: 3,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers,
    questionInfo: $setup.paperInfo.items[$setup.itemNo]
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[4] || (_cache[4] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_14, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["onSetAnswer", "allAnswers", "questionInfo"])) : _createCommentVNode("", true), $setup.paperInfo.items[$setup.itemNo].questionGroupList[0].questionMethod == 'writing' ? (_openBlock(), _createBlock(_component_writing_listen, {
    key: 4,
    onSetAnswer: $setup.setAnswer,
    allAnswers: $setup.cache.answers,
    questionInfo: $setup.paperInfo.items[$setup.itemNo]
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [[_vShow, $setup.audioStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[5] || (_cache[5] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.audioStatus == 'yet']]), _withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [[_vShow, $setup.audioStatus == 'over']])])]),
    _: 1
  }, 8, ["onSetAnswer", "allAnswers", "questionInfo"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.paperInfo.items ? (_openBlock(), _createBlock(_component_MenuBox, {
    key: 2,
    examType: $props.examInfo.subdivide,
    paperInfo: $setup.paperInfo,
    itemNo: $setup.itemNo,
    answers: $setup.cache.answers,
    onChangePaper: _cache[6] || (_cache[6] = $event => $setup.finishExam(3)),
    onChangeItem: _cache[7] || (_cache[7] = no => {
      $setup.saveAudioTime();
      $setup.itemNo = no < $setup.paperInfo.items.length ? no : $setup.paperInfo.items.length - 1;
      $setup.setCache();
    })
  }, null, 8, ["examType", "paperInfo", "itemNo", "answers"])) : _createCommentVNode("", true), $setup.paperInfo.items ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("p", _hoisted_20, _toDisplayString($setup.preLoadingText < $setup.paperInfo.items.length ? "正在加载试卷资源" : "加载成功！"), 1), _withDirectives(_createElementVNode("p", null, " 正在加载试卷音频资源..(" + _toDisplayString($setup.preLoadingText) + "/" + _toDisplayString($setup.paperInfo.items.length) + ") ", 513), [[_vShow, $setup.preLoadingText < $setup.paperInfo.items.length]]), _withDirectives(_createElementVNode("p", _hoisted_21, " 如加载过慢，建议关闭浏览器，更换网络环境重试。 ", 512), [[_vShow, $setup.preLoadingText < $setup.paperInfo.items.length]]), _withDirectives(_createElementVNode("p", null, " 加载资源完成，请点击确认开始考试 ", 512), [[_vShow, $setup.preLoadingText == $setup.paperInfo.items.length]]), _createElementVNode("div", null, [_withDirectives(_createVNode(_component_el_button, {
    size: "large",
    type: "primary",
    plain: "",
    onClick: _cache[8] || (_cache[8] = $event => {
      $setup.preLoading = false;
      $setup.setCountDown();
    })
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("确认", -1)]))]),
    _: 1
  }, 512), [[_vShow, $setup.preLoadingText == $setup.paperInfo.items.length]])])])], 512)), [[_vShow, $setup.preLoading]]) : _createCommentVNode("", true)], 64);
}